// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cfFU","left":"styles_left__3VldH","desktopActions":"styles_desktopActions__1iJ-4","title":"styles_title__2nSEq"};